<template>
  <div id="model-relic-dialog-header" class="x-center">
    <i class="iconfont icon-guanbi ctrl-close pointer" @click="handleClose"></i>
    <div class="header">
      <div class="header-title center">
        <span>{{ relicName }}</span>
      </div>
      <ul class="header-list x-center">
        <li
          class="header-list-item pointer"
          v-for="(item, index) in showList"
          :key="index"
          :class="{ isActive: modelValue === index + 1 }"
          @click="handleChangeTab(index)"
          v-show="item.visible"
        >
          {{ item.label }}
        </li>
      </ul>
    </div>
    <i
      class="iconfont iconicon-- ctrl-suofang pointer"
      v-show="visibleSuoFang"
      @click="handleChange"
    ></i>
    <i
      v-show="!visibleSuoFang"
      class="iconfont iconicon--1 ctrl-suofang pointer"
      @click="handleChange"
    ></i>
  </div>
</template>

<script>
import { mixinModel } from '../assets/js/model';
export default {
  name: 'ModelRelicDialogHeader',
  props: {
    relicName: {
      type: String,
      default: ''
    },
    relicInfo: {
      type: Object,
      required: true
    }
  },
  mixins: [mixinModel],
  data() {
    return {
      visibleSuoFang: true,
      showList: [
        {
          label: '建筑简介',
          visible: true
        },
        {
          label: '三维模型',
          visible: this.relicInfo.pointCloudUrl
        },
        {
          label: '测绘图纸',
          visible: this.relicInfo?.draw
        },
        {
          label: '实景照片',
          visible: this.relicInfo.realisticPic[0]
        }
      ]
    };
  },
  methods: {
    handleClose() {
      this.$emit('onCloseClick');
    },
    handleChange() {
      this.$emit('onChangeClick');
      this.visibleSuoFang = this.visibleSuoFang ? false : true;
    },
    handleChangeTab(index) {
      this.modelValue = index + 1;
    }
  }
};
</script>

<style lang="scss">
#model-relic-dialog-header {
  position: relative;
  color: #fff;
  width: 100vw;
  height: 5em;
  font-size: 20px;
  background-color: #000;
  .iconfont {
    font-size: 24px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .ctrl {
    &-suofang {
      right: 1em;
    }
    &-close {
      left: 1em;
    }
  }
  .isActive {
    color: $primary !important;
  }
  .header {
    width: 80vw;
    display: flex;
    justify-content: space-between;
    &-title {
      width: calc(80vw - 960px);
      min-width: 200px;
    }
    &-list {
      width: 960px;
      &-item {
        flex: 1;
        text-align: center;
        line-height: 5em;
      }
    }
  }
}
@media screen and (max-width: '960px') {
  #model-relic-dialog-header {
    font-size: 16px;
  }
}
</style>
